import React, { useState } from "react";

import { Button, Modal } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";

import { S3_URL } from "common/constants/apiUrls";

import "./ProductDeactivated.scss";
import { useTranslation } from "react-i18next";
const ProductDeactivated = ({
  product,
  show,
  handleClose,
  handleConfirm,
  btnLoader,
  branchName,
}) => {
  const {
    productId = "",
    productKey = "",
    translatedValue = "",
    productDescription = "",
    imageUrl = "",
    ownedSince = "",
    revenueTranslatedValue = "",
    assigned = "",
  } = product;
  const { t } = useTranslation();
  const [disabled, setDisabled] = useState(assigned);
  let productStatus = !assigned;

  // create regex
  // const regEx = new RegExp(translatedValue, "gi");

  return (
    <>
      <div className="product-deactivated">
        <Modal
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
          className="product-deactivated">
          <Modal.Header closeButton>
            <Modal.Title>
              {productStatus ? "Activating" : "Deactivating"} {t("product-access")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="question">
              {t("product-deactivate-confirmation-text-1")}{" "}
              {productStatus ? t("activate") : t("deactivate")}{" "}
              {t("product-deactivate-confirmation-text-2")} &nbsp;
              <b>{"VB " + branchName}</b>?
            </p>
            <div>
              <img src={`/assets/icons${imageUrl}`} className="rounded" />
              <span className="ms-2">{translatedValue}</span>
            </div>
            <p className="paragraph">
              {t("product-deactivate-confirmation-text-3")} {productStatus ? "gain" : "lose"}{" "}
              {t("product-deactivate-confirmation-text-4")}{" "}
              <b>
                {t("product-deactivate-confirmation-text-5")}{" "}
                {productStatus ? "activation" : "deactivation"}{" "}
                {t("product-deactivate-confirmation-text-6")}
              </b>
            </p>
            {!productStatus && (
              <div className="field-container mt-4">
                <input
                  type="text"
                  className="field"
                  placeholder={t("product-name-placeholder")}
                  onChange={(e) => {
                    let result = translatedValue === e.target.value;
                    if (result) setDisabled(false);
                    else setDisabled(true);
                  }}
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button className="cancel" variant="btn-transparent" onClick={handleClose}>
              {t("cancel")}
            </Button>
            <Button
              disabled={btnLoader || disabled}
              className={productStatus ? "activate" : "deactivate"}
              variant={productStatus ? "btn-success" : "btn-error"}
              onClick={handleConfirm}>
              {btnLoader ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  {`${productStatus ? "Activate" : t("deactivate")} `}
                </>
              ) : (
                `${productStatus ? "Activate" : t("deactivate")} `
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default ProductDeactivated;
